import { useTranslate } from '@tolgee/react'
import { useEffect } from 'react'
import { useBlocker } from 'react-router'

export function useNativeNavigationGuard(shouldQueryBeforPageLeave: boolean) {
  const blocker = useBlocker(shouldQueryBeforPageLeave)
  const { t } = useTranslate()

  useEffect(() => {
    if (blocker.state === 'blocked' && shouldQueryBeforPageLeave) {
      const confirmed = window.confirm(
        t('navigationGuardMessage', 'Changes you made may not be saved.'),
      )

      confirmed ? blocker.proceed() : blocker.reset()
    }
  }, [shouldQueryBeforPageLeave, blocker, t])

  useEffect(() => {
    if (!shouldQueryBeforPageLeave) return

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = ''
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [shouldQueryBeforPageLeave])
}
